module.exports = __webpack_public_path__ + "static/media/Panama-Wall-Juggling.48b71cf3.jpg";